import { DOCUMENT } from '@angular/common';
import { WizDividerBase } from './wiz-divider.component';
import { ElementRef, ViewContainerRef, Renderer2, ChangeDetectorRef, Component, Inject } from '@angular/core';

/**
 * Implémentation horizontale du WizBaseDivider
 */
@Component({
  selector: '<wiz-h-divider></wiz-h-divider>',
  templateUrl: './wiz-divider.component.html',
  styleUrls: ['./wiz-h-divider.component.scss']
})
export class WizHDividerComponent extends WizDividerBase {
  constructor(public elementRef: ElementRef,
              public vcRef: ViewContainerRef,
              public  renderer: Renderer2,
              protected cdref: ChangeDetectorRef,
              @Inject(DOCUMENT) protected document: Document) {
    super(elementRef, vcRef, renderer, cdref, document);
  }

  /**
   * Retourne la direction du divider divider: 'H' pour horizontal.
   */
  get direction(): 'H' | 'V' {
    return 'H';
  }
}
